import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
        // ns-color-black
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-0 ${className}`}
            onClick={() => filter.remove()}
            aria-label={`Remove filter ${filter.value}`}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()
    // console.log(filters);

    return (
        filters.length > 0 && (
            // ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-wrapper">
                <div class="ns-col-12 ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-container">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            // ns-px-1 ns-mr-1 ns-mb-1 ns-font-4
                            class="ns-selected-filter ns-d-flex ns-align-items-center"
                        >
                            {/* {filter.name}:  */}
                            <span class="ns-color-black">
                                {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                {/* <span
                    class="ns-anchor ns-col-2 ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </span> */}
            </div>
        )
    )
}
